import { initFreedomAuthStrategy } from './model';
import { unauthorizedAccessInterceptor } from './lib';

// export mock data separately to prevent getting into production bundle
export { defaultAuthData, mockDataStorageKey } from './config';

export const freedomAuth = {
  model: { initFreedomAuthStrategy },
  lib: { unauthorizedAccessInterceptor },
};
